import { useState } from 'react'
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'
import { appConfig } from '../../config/app'
import { useQuery } from '@tanstack/react-query'
import { apiClient, apiOrigin } from '../../lib/apiClient'
import { useAuth } from '../../features/auth/AuthContext'
import AccountMenu from '../../components/navigation/AccountMenu'

const links = [
  ['/', 'Home'],
  ['/appointment', 'Appointment'],
  ['/services', 'Services'],
  ['/schedule', 'Schedule'],
  ['/about', 'About'],
  ['/contact', 'Contact'],
] as const

export default function PublicLayout() {
  const { user, isInitializing } = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)
  const location = useLocation()
  const branding = useQuery({queryKey:['public-settings'],queryFn:async()=>(await apiClient.get<{data:Record<string,string>}>('/public/settings')).data.data})
  const siteName = branding.data?.site_name || appConfig.name

  return (
    <div className="public-shell">
      <header className="public-header">
        <Link className="public-brand" to="/" onClick={() => setMenuOpen(false)} aria-label={`${siteName} home`}>
          <span className="brand-icon"><i className="bi bi-heart-pulse" aria-hidden="true" /></span>
          {branding.data?.logo && <img src={apiOrigin+branding.data.logo} alt="Chamber logo" width="44" height="44" />}
          <span><strong>{siteName}</strong><small>{branding.data?.site_tagline || 'Healthcare anytime, anywhere'}</small></span>
        </Link>
        <button className="public-menu-button" type="button" onClick={() => setMenuOpen((value) => !value)} aria-expanded={menuOpen} aria-controls="public-navigation">
          <i className="bi bi-list" aria-hidden="true" /><span className="visually-hidden">Toggle navigation</span>
        </button>
        <nav id="public-navigation" className={`public-navigation ${menuOpen ? 'show' : ''}`} aria-label="Public navigation" onKeyDown={event => { if (event.key === 'Escape') { setMenuOpen(false); document.querySelector<HTMLButtonElement>('.public-menu-button')?.focus() } }}>
          {links.map(([to, label]) => (
            <NavLink key={to} to={to} end={to === '/'} onClick={() => setMenuOpen(false)}>{label}</NavLink>
          ))}
        </nav>
        <div className="public-auth-actions">
          {isInitializing ? <span role="status">Loading account…</span> : user ? <AccountMenu /> : <>
          <Link className="btn btn-light" to="/login" state={{ from: location.pathname }}>Login</Link>
          <Link className="btn btn-primary" to="/register">Sign Up</Link>
          </>}
        </div>
      </header>
      <main className="public-main"><Outlet /></main>
      <footer className="public-footer">
        <div><strong>{siteName}</strong><span>{branding.data?.footer_text || 'Online consultation is not an emergency service.'}</span></div>
        <nav aria-label="Policy links"><a href="#privacy">Privacy</a><a href="#terms">Terms</a><a href="#refunds">Refund policy</a></nav>
      </footer>
    </div>
  )
}
